export default __webpack_public_path__ + "static/media/longchamp11.016e08c0.jpg";